"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NumberFormatterServiceV1 = void 0;
const createIntlNumberFormat_1 = require("./utils/createIntlNumberFormat");
class NumberFormatterServiceV1 {
    constructor(config, logger) {
        try {
            this.numberFormatter = (0, createIntlNumberFormat_1.createNumberFormatter)(config, logger);
            this.currencyFormatter = (0, createIntlNumberFormat_1.createCurrencyFormatter)(config, logger);
        }
        catch (err) {
            logger?.error(`Error initializing formatters: ${err}`);
            throw err;
        }
    }
    formatNumber(value) {
        return this.numberFormatter.format(value);
    }
    formatCurrency(value) {
        return this.currencyFormatter.format(value);
    }
}
exports.NumberFormatterServiceV1 = NumberFormatterServiceV1;
//# sourceMappingURL=v1.js.map